import { f as VueComponentMixin, B as BaseComponentMixin } from './plugins-4daf8ef8.js';
import { resolveComponent, openBlock, createBlock, renderSlot, Fragment, createTextVNode, toDisplayString, createCommentVNode, createVNode, withCtx } from 'vue';

var script = {
  name: 'OFieldBody',
  mixins: [VueComponentMixin()],
  inject: {
    $field: {
      name: '$field',
      default: false
    }
  },
  computed: {
    parent() {
      return this.$field;
    }

  },

  render() {
    if (!this.vueReady) return;
    let first = true;
    return this.$createElement('div', {
      attrs: {
        'class': this.parent.contentHorizontalClasses
      }
    }, this.getSlotInstance('default').map(element => {
      // skip returns and comments
      if (!element.tag) {
        return element;
      }

      let message;

      if (first) {
        message = this.parent.newMessage;
        first = false;
      }

      return this.$createElement(this.parent.rootClass, {
        attrs: {
          variant: this.parent.newVariant,
          message
        }
      }, [element]);
    }));
  }

};

script.__file = "oruga/src/components/field/FieldBody.vue";

/**
 * Fields are used to add functionality to controls and to attach/group components and elements together
 * @displayName Field
 * @example ./examples/Field.md
 * @style _field.scss 
 */

var script$1 = {
  name: 'OField',
  components: {
    [script.name]: script
  },
  mixins: [VueComponentMixin(), BaseComponentMixin],

  provide() {
    return {
      $field: this
    };
  },

  inject: {
    $field: {
      name: '$field',
      default: false
    }
  },
  props: {
    /**
     * 	Color of the field and help message, also adds a matching icon, optional. Used by Input, Select and Autocomplete
     *  @values primary, info, success, warning, danger, and any other custom color
     */
    variant: [String, Object],

    /**
     * Field label
     */
    label: String,

    /**
     * Same as native for set on the label
     */
    labelFor: String,

    /**
     * Help message text
     */
    message: String,

    /**
     * Direct child components/elements of Field will be grouped horizontally (see which ones at the top of the page)
     */
    grouped: Boolean,

    /**
     * Allow controls to fill up multiple lines, making it responsive
     */
    groupMultiline: Boolean,
    expanded: Boolean,

    /**
     * Group label and control on the same line for horizontal forms
     */
    horizontal: Boolean,

    /**
     * Field automatically attach controls together
     */
    addons: {
      type: Boolean,
      default: true
    },
    rootClass: String,
    horizontalClass: String,
    expandedClass: String,
    groupMultilineClass: String,
    labelClass: String,
    labelHorizontalClass: String,
    contentHorizontalClass: String,
    messageClass: String,
    variantClass: String
  },

  data() {
    return {
      newVariant: this.variant,
      newMessage: this.message
    };
  },

  computed: {
    messageClasses() {
      return [this.computedClass('field', 'messageClass', 'o-field-message'), {
        [`${this.computedClass('field', 'variantClass', 'o-color-')}${this.newVariant}`]: this.newVariant
      }];
    },

    labelClasses() {
      return [this.computedClass('field', 'labelClass', 'o-field-label')];
    },

    labelHorizontalClasses() {
      return [this.computedClass('field', 'labelHorizontalClass', 'o-field-horizontal-label')];
    },

    contentHorizontalClasses() {
      return [this.computedClass('field', 'contentHorizontalClass', 'o-field-horizontal-content')];
    },

    innerFieldClasses() {
      return [{
        [this.computedClass('field', 'groupMultilineClass', 'o-field-grouped-multiline')]: this.groupMultiline
      }, this.fieldType()];
    },

    parent() {
      return this.$field;
    },

    hasDefaultSlot() {
      return this.existsSlot('default');
    },

    hasLabelSlot() {
      return this.existsSlot('label');
    },

    hasMessageSlot() {
      return this.existsSlot('message');
    },

    hasLabel() {
      return this.label || this.hasLabelSlot;
    },

    hasMessage() {
      return (!this.parent || !this.parent.hasInnerField) && this.newMessage || this.hasMessageSlot;
    },

    hasInnerField() {
      return this.grouped || this.groupMultiline || this.hasAddons();
    }

  },
  watch: {
    /**
    * Set internal variant when prop change.
    */
    variant(value) {
      this.newVariant = value;
    },

    /**
    * Set internal message when prop change.
    */
    message(value) {
      this.newMessage = value;
    },

    /**
    * Set parent message if we use Field in Field.
    */
    newMessage(value) {
      if (this.parent && this.parent.hasInnerField) {
        this.parent.newMessage = value;
      }
    }

  },
  methods: {
    rootClasses() {
      return [this.computedClass('field', 'rootClass', 'o-field')];
    },

    /**
    * Field has addons if there are more than one slot
    * (element / component) in the Field.
    * Or is grouped when prop is set.
    * Is a method to be called when component re-render.
    */
    fieldType() {
      if (this.grouped) return 'o-field-grouped';
      if (this.hasAddons()) return 'o-field-addons';
    },

    hasAddons() {
      let renderedNode = 0;

      if (this.hasDefaultSlot) {
        renderedNode = this.getSlotInstance('default').reduce((i, node) => node.tag ? i + 1 : i, 0);
      }

      return renderedNode > 1 && this.addons && !this.horizontal;
    }

  }
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_o_field_body = resolveComponent("o-field-body");
  const _component_o_field = resolveComponent("o-field");

  return (_ctx.vueReady)
    ? (openBlock(), createBlock("div", {
        key: 0,
        class: $options.rootClasses()
      }, [
        ($props.horizontal)
          ? (openBlock(), createBlock("div", {
              key: 0,
              class: $options.labelHorizontalClasses
            }, [
              ($options.hasLabel)
                ? (openBlock(), createBlock("label", {
                    key: 0,
                    for: $props.labelFor,
                    class: $options.labelClasses
                  }, [
                    ($options.hasLabelSlot)
                      ? renderSlot(_ctx.$slots, "label", { key: 0 })
                      : (openBlock(), createBlock(Fragment, { key: 1 }, [
                          createTextVNode(toDisplayString($props.label), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                  ], 10 /* CLASS, PROPS */, ["for"]))
                : createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : (openBlock(), createBlock(Fragment, { key: 1 }, [
              ($options.hasLabel)
                ? (openBlock(), createBlock("label", {
                    key: 0,
                    for: $props.labelFor,
                    class: $options.labelClasses
                  }, [
                    ($options.hasLabelSlot)
                      ? renderSlot(_ctx.$slots, "label", { key: 0 })
                      : (openBlock(), createBlock(Fragment, { key: 1 }, [
                          createTextVNode(toDisplayString($props.label), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                  ], 10 /* CLASS, PROPS */, ["for"]))
                : createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */)),
        ($props.horizontal)
          ? createVNode(_component_o_field_body, { key: 2 }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            })
          : ($options.hasInnerField)
            ? (openBlock(), createBlock("div", {
                key: 3,
                class: $options.contentHorizontalClasses
              }, [
                createVNode(_component_o_field, {
                  addons: false,
                  class: $options.innerFieldClasses
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "default")
                  ]),
                  _: 3
                }, 8 /* PROPS */, ["class"])
              ], 2 /* CLASS */))
            : renderSlot(_ctx.$slots, "default", { key: 4 }),
        ($options.hasMessage && !$props.horizontal)
          ? (openBlock(), createBlock("p", {
              key: 5,
              class: $options.messageClasses
            }, [
              ($options.hasMessageSlot)
                ? renderSlot(_ctx.$slots, "message", { key: 0 })
                : (openBlock(), createBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString($props.message), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
            ], 2 /* CLASS */))
          : createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : createCommentVNode("v-if", true)
}

script$1.render = render;
script$1.__file = "oruga/src/components/field/Field.vue";

export { script$1 as s };
